export const data = [
	{
		video: 'zwirn.mp4',
		image: 'zwirn-thumb.jpg',
		title: 'Naše projekty',
		body: '<p>Geometrický model LOD 300 koncových prvkov silnoprúdových rozvodov, štruktúrovanej kabeláže, EPS, HSP, EZS, bleskozvodu a ' +
			'areálového osvetlenia. Káblové rozvody vymodelované v reálnych rozmeroch, v reálnych trasách / uloženiach – ' +
			'prepočet na vzájomné oteplenie NN rozvodov, prepočet zaťaženia žľabov. Namodelované reálne káblové ukončenia – ' +
			'odpady po osadení prístrojov. Do projektu vložených viac ako 3,5 mil. parametrov. Výkaz výmer takmer totožný s realitou.</p>' +
			'<a target="_blank" href="https://www.youtube.com/watch?v=SbwoBMDITQs"><div class="flex flex-row items-center">' +
			'<img src="img/public/icons/list_icon_blue.png" class="list-icon"> Pozrite si náš webinár' +
			'</div></a>',
	},
	{
		image: '1-lean.jpg',
		title: 'Lean Construction',
		body: '<p>Lean proces je súbor nástrojov pre zlepšenie stavebných procesov s minimálnymi nákladmi a maximálnou hodnotou ' +
			'na základe zohľadnenia potrieb zákazníka, zatiaľ čo pomáha dosahovať a udržiavať ciele udržateľnosti vo všetkých troch dimenziách planéty, ' +
			'ľudí a zisku v rámci celého dodávateľského reťazca v stavebníctve.</p>\n' +
			'<p>V samotnej príprave stavby využívame nástroje pre modelovanie, riadenie a komunikáciu. ' +
			'Pre spravovanie modelu metódou BIM využívame softwarový nástroj Revit Autodesk.</p>',
	},
	{
		image: '2-1-bim.jpg',
		title: 'Modelovanie metódou BIM <h1 class="text-sm -mt-1">(Building information modeling)</h1>',
		body: '<h1>Prečo BIM?</h1>\n' +
			'<p>Výhodou modelovania metódou BIM je vyriešenie takmer všetkých technických detailov a kolízií ' +
			'čo pri bežných 2D metódach nie je možné a jednotlivé nedostatky sa ukážu až na stavbe, filtrovanie položiek napr. ' +
			'do rozpočtu na základe vhodne vyplnených parametrov, presný rozpočet (odchýlka cca 7% oproti 2D metódam) – ' +
			'takmer reálna informácia o celkových investičných nákladoch už v procese prípravy stavby.</p>',
	},
	{
		image: '2-2-bim.jpg',
		title: 'Modelovanie metódou BIM <h1 class="text-sm -mt-1">(Building information modeling)</h1>',
		body: '<h1>Je BIM drahý?</h1>\n' +
			'<p>Príplatok za BIM je rádovo nižší ako prípadné zmeny realizované už v procese výstavby. Avšak BIM nenahrádza skúsenosti projektanta!<p>\n' +
			'<h1>Prečo Revit Autodesk</h1>\n' +
			'<p>100% kompatibilita s CAD softwarmi, neobmedzená parametrizácia položiek, reálna 3D geometria všetkých prvkov vrátané káblových rozvodov, ' +
			'kompatibilita exportu *.ifc s ostatnými výpočtovými softwarmi napr. Dialux, vhodné na veľké stavby</p>',
	},
	{
		image: '3-1-dialux.jpg',
		title: 'Výpočet umelého a núdzového osvetlenia',
		body: '<p>Export ifc modelu do výpočtového softwaru Dialux umožňuje simulovať ' +
			'intenzitu osvetlenia presne na požadovaných plochách, ktorých geometria má reálne kontúry. V Dialuxe sa dajú nastaviť ' +
			'presné materiály povrchov, ich odrazivosť a činiteľ údržby, čo má dopad na samotný návrh osvetľovacej sústavy. ' +
			'V zmysle STN sa musí na tieto aspekty prihliadať.</p>',
	},
	{
		image: '3-2-dialux.jpg',
		title: 'Výpočet umelého a núdzového osvetlenia',
		body: '<p>Export ifc modelu do výpočtového softwaru Dialux umožňuje simulovať ' +
			'intenzitu osvetlenia presne na požadovaných plochách, ktorých geometria má reálne kontúry. V Dialuxe sa dajú nastaviť ' +
			'presné materiály povrchov, ich odrazivosť a činiteľ údržby, čo má dopad na samotný návrh osvetľovacej sústavy. ' +
			'V zmysle STN sa musí na tieto aspekty prihliadať.</p>',
	},
	{
		image: '4-sichr.jpg',
		title: 'Výpočet parametrov vedení',
		body: '<p>Všetky naše riešenia sú podložené výpočtom. Príkladom je simulácia ' +
			'hlavných rozvodov v programe Sichr. Vedenia sú počítané na úbytok napätia, oteplenie, prúdové zaťaženie a impedanciu ' +
			'vypínacej slučky. Následne sú vedenia reálne vymodelované s prípadnými vzájomnými odstupmi.</p>',
	},
	{
		image: '5-hsp.jpg',
		title: 'Simulácia akustiky HSP',
		body: '<p>Pre správny návrh systému HSP sa prostredníctvom výpočtového softwaru simuluje zrozumiteľnosť a akustický tlak. ' +
			'Výsledkom je, že pri vyhlásení požiarneho poplachu na stavbe je hovorové slovo zrozumiteľné v každom mieste.</p>',
	},
	{
		image: '6-cctv.jpg',
		title: 'Simulácia CCTV',
		body: '<p>Pre správny návrh systému CCTV sa prostredníctvom výpočtového softwaru simuluje rozpoznávanie tváre alebo ŠPZ podľa potrieb zákazníka.</p>',
	},
	{
		image: '7-1-kolizia.jpg',
		title: 'Detekcia kolízií, koordinácia',
		body: '<p>Detekcia kolízií je príkladom benefitu 3D softwárov. Odstránením kolíznych miest už v priebehu projektu sa šetrí čas a ' +
			'financie vo výstavbe. Zároveň sa znižujú personálne nároky na riadenie výstavby.</p>',
	},
	{
		image: '7-2-kolizia.jpg',
		title: 'Detekcia kolízií, koordinácia',
		body: '<p>Detekcia kolízií je príkladom benefitu 3D softwárov. Odstránením kolíznych miest už v priebehu projektu sa šetrí čas a ' +
			'financie vo výstavbe. Zároveň sa znižujú personálne nároky na riadenie výstavby.</p>',
	},
	{
		image: '7-3-koordinacia.jpg',
		title: 'Detekcia kolízií, koordinácia',
		body: '<p>Detekcia kolízií je príkladom benefitu 3D softwárov. Odstránením kolíznych miest už v priebehu projektu sa šetrí čas a ' +
			'financie vo výstavbe. Zároveň sa znižujú personálne nároky na riadenie výstavby.</p>',
	},
	{
		image: '8-last-planner.jpg',
		title: 'Riadenie projektu / komunikačné nástroje',
		body: '<p>Významné rozdiely vznikajú počas projekčných prác a to najmä v spôsobe riadenia projektu. Lean construction nám umožňuje využitie ' +
			'tzv. napr. Last planneru ako nástroj pre zadávanie a vyhodnotenie jednotlivých úloh alebo CDE (common data environment), čo predstavuje nejaké spoločné cloudové ' +
			'prostredie, na ktoré sa môžu na základe dohody medzi GP, investorom a projekčným tímom periodicky nahrávať rozpracované modely. Okrem toho, že tieto modely môže ' +
			'investor už počas projekčných prác pripomienkovať je veľkou výhodou fakt, že každá profesia má aktuálnu rozpracovanosť ostatných profesií, čo pri dobrom projekčnom ' +
			'tíme môže napomôcť ku koordinácii primao počas spracovania technického riešenia.</p>',
	},
	{
		image: '9-01-rozvodna.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-02-suteren.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-03-kable.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-04-kable.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-05-koordinak.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-06-byt.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-07.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-08.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-09.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-10.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
	{
		image: '9-11.jpg',
		title: 'Naše projekty',
		body: '<p>Modelovanie koncových prvkov je z pohľadu času porovnateľné s 2D metódami. Modelovanie rozvodov patrí medzi najnáročnejšie úkony, ' +
			'čím je samozrejme ovplyvnená aj cena projektu, preto treba zvážiť kedy to má význam a kedy nie. Význam má z pohľadu kompletného projektu, priestorovej orientácie, ' +
			'podrobnej koordinácie, tvorby káblovej listiny, presného vyčíslenia investičných nákladov, pri správe budovy.</p>\n' +
			'<p>Bleskozvod a uzemnenie - mimo priestorovej koordinácie, ktorá je naozaj veľkým prínosom pri projektovaní každej časti je napr. fakt, že ' +
			'si sám projektant alebo zhotoviteľ stavby môže vyhotoviť akýkoľvek detail, pohľad alebo rez.</p>',
	},
];
